import React from "react";
import TransactionSummary from "../Transactions/TransactionSummary";

interface SummaryBoardProps {
  selectedPeriod: string;
  loading: boolean;
  onRefresh: () => void;
  onRefreshComplete?: () => void;
  onLoadingChange?: (loading: boolean) => void;
  onPeriodChange: (period: string) => void;
}

const SummaryBoard: React.FC<SummaryBoardProps> = ({
  selectedPeriod,
  loading,
  onRefresh,
  onRefreshComplete,
  onLoadingChange,
  onPeriodChange,
}) => {
  return (
    <div className="dashboard-content">
      <TransactionSummary
        selectedPeriod={selectedPeriod}
        loading={loading}
        onRefresh={onRefresh}
        onRefreshComplete={onRefreshComplete}
        onLoadingChange={onLoadingChange}
        onPeriodChange={onPeriodChange}
      />
    </div>
  );
};

export default SummaryBoard;
